import AGREGAR_PRESUPUESTO from '@/graphql/mutations/administracion/presupuestos/agregarPresupuesto.gql';
import PRESUPUESTOS from '@/graphql/querys/administracion/presupuestos/presupuestos.gql';
import ACTUALIZAR_PRESUPUESTO from '@/graphql/mutations/administracion/presupuestos/actualizarPresupuesto.gql';
import REMOVER_PRESUPUESTO from '@/graphql/mutations/administracion/presupuestos/removerPresupuesto.gql';
import FUENTES_FINANCIERAS from '@/graphql/querys/administracion/catalogos/fuentesfinancieras/fuentesFinancieras.gql';

export default {
  apollo: {
    presupuestos: {
      query: PRESUPUESTOS,
    },
    fuentesFinancieras: {
      query: FUENTES_FINANCIERAS,
    },
  },
  data() {
    return {
      enviandoFormulario: false,
      ejercicios: [],
    };
  },
  mounted() {
    this.setEjercicios();
  },
  methods: {
    setEjercicios() {
      this.ejercicios = [];
      const yr = Number(new Date().toISOString().substr(0, 4));
      const min = yr - 10;
      const max = yr + 1;
      // eslint-disable-next-line no-plusplus
      for (let index = max; index >= min; index--) {
        this.ejercicios.push(index);
      }
    },
    async mixAgregarPresupuesto() {
      this.enviandoFormulario = true;
      this.mixEsCargando();

      await this.$apollo.mutate({
        mutation: AGREGAR_PRESUPUESTO,
        variables: {
          presupuesto: this.presupuesto,
        },
        update: (store, { data: { agregarPresupuesto } }) => {
          const data = store.readQuery({ query: PRESUPUESTOS });
          data.presupuestos.push(agregarPresupuesto);
          store.writeQuery({ query: PRESUPUESTOS, data });
        },
      })
        .then(() => this.mixMensajeSuccess())
        .catch((err) => this.mixMensajeError(err));

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },
    async mixActualizarPresupuesto() {
      this.enviandoFormulario = true;
      this.mixEsCargando();

      await this.$apollo.mutate({
        mutation: ACTUALIZAR_PRESUPUESTO,
        variables: {
          id: this.presupuestoId,
          presupuesto: this.editarPresupuesto,
        },
        update: (store, { data: { actualizarPresupuesto } }) => {
          const data = store.readQuery({ query: PRESUPUESTOS });
          const { presupuestos } = data;
          const index = presupuestos.findIndex(({ id }) => id === actualizarPresupuesto.id);
          if (index !== -1) {
            presupuestos.splice(index, 1, actualizarPresupuesto);
          }
          store.writeQuery({ query: PRESUPUESTOS, data });
        },
      })
        .then(() => this.mixMensajeSuccess())
        .catch((err) => this.mixMensajeError(err));

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },
    async mixEliminarPresupuesto() {
      this.enviandoFormulario = true;
      this.mixEsCargando();

      await this.$apollo.mutate({
        mutation: REMOVER_PRESUPUESTO,
        variables: { id: this.presupuestoEliminar.id },
        update: (store) => {
          const data = store.readQuery({ query: PRESUPUESTOS });
          const { presupuestos } = data;

          const index = presupuestos.findIndex(({ id }) => id === this.presupuestoEliminar.id);
          if (index === -1) return;

          presupuestos.splice(index, 1);
          store.writeQuery({ query: PRESUPUESTOS, data });
        },
      })
        .then(() => this.mixMensajeSuccess())
        .catch((err) => this.mixMensajeError(err));

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
      // this.cerrar();
    },
  },
};
